<template>
  <div id="app" class="w-full h-full">
    <router-view/>
    <notifications group="app-notify"/>
  </div>
</template>
<script>
export default {
  name: "RootApp",
  computed: {
    website() {
      return this.$store.getters["app/website"] || {};
    }
  },

  watch: {
    "$route"(val) {
      document.title = val.meta.name || "mobiedu.vn";
    }
  },
  async  created() {
  }
}
</script>
